import { Participant } from "../Participant";
import { User } from "../User";

export type ExamPeriodMonitorUserLogin = {
    loggedInAt: string;
    ipAddress: string;
    proxyIPAdress: string;
    userAgent: string;
    tokenValue: string;
}

export type ExamPeriodMonitorProctoringEvent = {
    id: string;
    eventType: string;
    eventSource: string;
    sessionId: string;
    safeExamBrowserDetected: boolean;
    userAgent: string;
    ipAddress: string;
    details: string;
    dateCreated?: string;
}

export type ExamPeriodMonitorActionLog = {
    id: string;
    oldState: ExamPeriodMonitorState;
    newState: ExamPeriodMonitorState;
    action: string;
    actorName?: string;
    actorEmail?: string;
    dateCreated?: string;
}

/** Autoritativni snapshot timera (najrobusnija sinkronizacija). */
export type ExamTimerSync = {
    examInstanceId: string;
    serverNowUnixMs: number;
    remainingSeconds: number | null;
    endsAtUnixMs: number | null;
    isRunning: boolean;
    state: number;
};

export type ExamPeriodMonitor = {
    id: string;
    title: string;
    participant: Participant;
    state: ExamPeriodMonitorState;
    totalScore: number;
    hasPassed: boolean;
    questionTimer?: number;
    groupTimer?: number;
    instanceTimer?: number;
    sync?: ExamTimerSync;
    userExaminee: User;
    percentageOfCompletion: number;
    userLogins: ExamPeriodMonitorUserLogin[];
    proctoringEvents: ExamPeriodMonitorProctoringEvent[];
    monitorActionLogs: ExamPeriodMonitorActionLog[];
    sessionCount: number;
    hasMultipleSessions: boolean;
    requiresSafeExamBrowser: boolean;
    hasSafeExamBrowserDetected: boolean;
    hasSafeExamBrowserViolation: boolean;
    lastProctoringEventAt?: string;
    lastExitAt?: string;
    startedAt?: string;
}

export enum ExamPeriodMonitorState {
    WaitingForParticipant = 1,
    ParticipantConfirmed = 2,
    NoShow = 3,
    InProgress = 4,
    Paused = 5,
    Excluded = 6,
    Completed = 7,
    Error = 8
}